export const NOT_PROVIDED = "Not Provided";
export const CUSTOMER_REVIEW_QUEUE = "CustomerReviewQueue"; 

export const EMAIL = "EMAIL";
export const TEXT = "TEXT";